import Validator from 'geojson-validation';
import { capitalize, isArray, isNil, noop } from 'lodash';

export function validateGeoJson(geoJson) {
    // null/undefined values are assumed valid, there is nothing there
    if (isNil(geoJson)) return true;

    try {
        const errors = Validator.valid(geoJson, noop);

        if (isArray(errors) && errors.length > 0) {
            const [err] = errors;
            return capitalize(String(err));
        }
    } catch (e) {
        return String(e);
    }

    return true;
}
